export const ACTION_LIST_USERSADMIN = "ACTION_LIST_USERSADMIN";
export const ACTION_DELETE_USERSADMIN = "ACTION_DELETE_USERSADMIN";
export const ACTION_POST_CREATE_USERSADMIN = "ACTION_POST_CREATE_USERSADMIN";
export const ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT = "ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT";
export const ACTION_GET_USERSADMIN_LIST_TYPE_ROL = "ACTION_GET_USERSADMIN_LIST_TYPE_ROL";
export const ACTION_GET_USERSADMIN_ID = "ACTION_GET_USERSADMIN_ID";
export const ACTION_PUT_UPDATE_USERSADMIN = "ACTION_PUT_UPDATE_USERSADMIN";
export const ACTION_GET_USERSADMIN_COMPANY_ID = "ACTION_GET_USERSADMIN_COMPANY_ID";
export const ACTION_PUT_UPDATE_USERSADMIN_COMPANY_ID = "ACTION_PUT_UPDATE_USERSADMIN_COMPANY_ID";
export const ACTION_POST_CREATE_CARGUE_EXCEL = "ACTION_POST_CREATE_CARGUE_EXCEL";
export const ACTION_GET_AFFILIATEDUSERS_LIST_GENDER = "ACTION_GET_AFFILIATEDUSERS_LIST_GENDER";
export const ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES = "ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES";
export const ACTION_GET_USERSTATUS = "ACTION_GET_USERSTATUS";
export const ACTION_POST_USERSTATUS = "ACTION_POST_USERSTATUS";